import Api from '@utils/api';
import { Plantillas } from '@constants/urls';
import _ from 'lodash';

export const state = {
	plantillas: {}
};

export const getters = {
	getPlantillas(state) {
		return state.plantillas;
	}
};

export const mutations = {
	SET_PLANTILLAS(state, plantillas) {
		state.plantillas = plantillas;
	}
};

export const actions = {
	inicializar({ commit }) {
		if (_.isEmpty(state.plantillas)) {
			Api.Get(Plantillas.LISTAR).then((response) => {
				const plantillas = {};
				response.data.forEach(
					(plantilla) => (plantillas[plantilla.nombrePlantilla] = plantilla.url)
				);
				commit('SET_PLANTILLAS', plantillas);
			});
		}
	}
};
